import type { ReactNode } from "react";
import {
  ListBox,
  ListBoxItem,
  Popover,
  Select,
} from "react-aria-components";

import { cn } from "@/shared/lib/cn";
import "./merryChoiceSurfaces.css";

export interface MerrySelectOption {
  id: string;
  label: string;
  content?: ReactNode;
}

interface MerrySelectOptionsProps {
  ariaLabel: string;
  children: ReactNode;
  className?: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  name?: string;
  onChange: (id: string) => void;
  options: readonly MerrySelectOption[];
  popoverClassName?: string;
  selectedId: string;
}

/** A controlled, keyboard-accessible select. Its caller owns the selected value. */
export function MerrySelectOptions({
  ariaLabel,
  children,
  className,
  isDisabled,
  isRequired,
  name,
  onChange,
  options,
  popoverClassName,
  selectedId,
}: MerrySelectOptionsProps) {
  return (
    <Select
      aria-label={ariaLabel}
      className={className}
      isDisabled={isDisabled}
      isRequired={isRequired}
      name={name}
      onSelectionChange={(key) => {
        if (key !== null && String(key) !== selectedId) onChange(String(key));
      }}
      selectedKey={selectedId}
    >
      {children}
      <Popover
        className={cn("merry-select-options", popoverClassName)}
        placement="bottom"
      >
        <ListBox className="merry-select-options__list">
          {options.map((option) => (
            <ListBoxItem
              className="merry-select-options__item"
              id={option.id}
              key={option.id}
              textValue={option.label}
            >
              {option.content ?? option.label}
            </ListBoxItem>
          ))}
        </ListBox>
      </Popover>
    </Select>
  );
}
